export const isLoggedIn = () => {
    let token = localStorage.getItem("userToken");
    return token !== "" && token !== null;
}

export const logOut = () => {
    localStorage.removeItem("currentUser");
}

export const logIn = ({token}) => {
    localStorage.setItem("token", token);
}
